import { html } from "lit-html"
import { DialogGet } from "./helpers"
import { SYSDialogBase } from "./sysdialog2base"
import { DialogGetParts } from "./sysdialogholder"
import { FieldVal, SYSField } from "../forms/fieldapi"
import { FormIsDirty, SYSFormState } from "../forms/formapi"
import { SYSTableData } from "../table/table"
import { TableGet } from "../table/tableapi"
import { DialogClose, DialogOkCancel } from "./dialogapi"
import { FormBodyRenderer } from "../table/helpers"
import { SYSState } from "../.."
import { T } from "../../textapi"
import { SYSOkCancelDeleteFooterType } from "../forms/controls/parts/okcanceldeletefooter"
import {
  HookFormEditorCancel,
  HookFormEditorDelete,
  HookFormEditorSave,
} from "../../global/hooks"

export class SYSEditorDialogBase extends SYSDialogBase {
  sourceField: SYSField
  parentForm: SYSFormState
  parentTableDef: SYSTableData

  saveHook: any
  deleteHook: any
  cancelHook: any

  async init() {
    this.formId = this.dialogInstance
    this.formState = this.state.ovl.forms[this.formType][this.formId]
    this.parentForm =
      this.state.ovl.forms[this.formState.parent.formType][
        this.formState.parent.formId
      ]
    this.sourceField = this.parentForm.fields[this.formState.parent.fieldKey]
    if (this.parentForm.tableDefId) {
      this.parentTableDef = TableGet(this.parentForm.tableDefId).dataDef
    }
    let fn = this.actions.app.features[this.formState.feature]

    if (fn) {
      this.saveHook =
        fn?.hooks[
          HookFormEditorSave.replace("{subFeature}", this.formState.subFeature)
        ]
      if (!this.saveHook) {
        throw Error(`ovl editor ${this.dialog}: HookFormEditorSave not found`)
      }
      this.deleteHook =
        fn?.hooks[
          HookFormEditorDelete.replace(
            "{subFeature}",
            this.formState.subFeature
          )
        ]
      this.cancelHook =
        fn?.hooks[
          HookFormEditorCancel.replace(
            "{subFeature}",
            this.formState.subFeature
          )
        ]
    }
  }
  close() {
    DialogClose(this.dialog, {
      instance: this.formId,
    })
  }

  async getUI() {
    let dialogParts: DialogGetParts = {
      dismissedCallbackFn: () => {
        return
      },
      title: () => {
        // check for specific feature (=baseFeature+dialogid) text and priorize it
        //`${feature}${parentField.editor.id}${parentField.fieldKey}
        let prefix = this.sourceField.editor.translationPrefix
        if (!prefix) {
          prefix = ""
        }
        let transKey = `${this.formState.feature}${prefix}${this.formState.subFeature}${this.sourceField.fieldKey}`
        if (!this.state.ovl.language.translations[transKey]) {
          transKey = `${this.formState.feature}${prefix}${this.formState.subFeature}`
          if (!this.state.ovl.language.translations[transKey]) {
            transKey = `${this.formState.subFeature}${prefix}`
            if (!this.state.ovl.language.translations[transKey]) {
              transKey = `${this.formState.subFeature}`
            }
          }
        }
        return T(transKey)
      },
      body: () => this.getBody(),
      footer: () => {
        let handleSave = async () => {
          let res = await this.saveHook({
            formState: this.formState,
            parentField: this.sourceField,
          })
          if (res?.cancel !== true) {
            this.close()
          }
        }
        let handleDelete = async () => {
          let res = await this.deleteHook({
            formState: this.formState,
            parentField: this.sourceField,
          })
          if (res?.cancel !== true) {
            this.close()
          }
        }

        let handleCancel = async () => {
          if (!this.cancelHook) {
            if (
              !FormIsDirty(this.formState) ||
              (await DialogOkCancel(T("SYSCancel"))) === 1
            ) {
              this.close()
            }
          } else {
            let res = await this.cancelHook({
              formState: this.formState,
              parentField: this.sourceField,
            })
            if (res?.cancel !== true) {
              this.close()
            }
          }
        }
        return html`<ovl-okcanceldeletefooter
          .props=${(state: SYSState): SYSOkCancelDeleteFooterType => {
            return {
              cancelFn: handleCancel,
              formState: this.formState,
              okFn: handleSave,
              deleteFn: this.deleteHook ? handleDelete : undefined,
              dialog: this.dialog,
            }
          }}
        ></ovl-okcanceldeletefooter>`
      },
    }
    return await DialogGet(this, dialogParts)
  }
  async getBody() {
    // use the default form renderer (same as bigform renderer)
    // so all control types are supported (editor on editor needs testing)
    // this will also respect FormBody Hooks

    let res = FormBodyRenderer(
      this.formState,
      {
        feature: this.formState.feature,
        columns: this.formState.fields,
        options: { rendering: { groups: this.sourceField._state.groupState } },
      },
      this.parentForm.row,
      this.parentTableDef?.data,
      this.parentForm.tableRowKey
    )

    return res
  }
  async firstUpdated() {}
}
